module.exports = __webpack_public_path__ + "static/media/thumb-vf.b91f8401.svg";